// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type DebouncedFunction<T extends (...args: any[]) => any> = (
  ...args: Parameters<T>
) => Promise<Awaited<ReturnType<T>>>

interface DebouncedPromise<T> {
  resolve: (result: T) => void
  reject: (reason?: unknown) => void
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debounce<T extends (...args: any[]) => any>(
  func: T,
  waitMilliseconds = 50,
): DebouncedFunction<T> {
  let timeoutId: ReturnType<typeof setTimeout> | undefined

  let promises: DebouncedPromise<Awaited<ReturnType<T>>>[] = []

  function nextInvokeTimeout() {
    return waitMilliseconds
  }

  const debouncedFunction = function (
    ...args: Parameters<T>
  ): Promise<Awaited<ReturnType<T>>> {
    return new Promise<Awaited<ReturnType<T>>>((resolve, reject) => {
      const invokeFunction = async () => {
        timeoutId = undefined

        try {
          const result = await func(...args)
          promises.forEach(({ resolve }) => resolve(result))
          promises = []
        } catch (error) {
          promises.forEach(({ reject }) => reject(error))
          promises = []
        }
      }

      if (timeoutId !== undefined) {
        clearTimeout(timeoutId)
      }

      timeoutId = setTimeout(invokeFunction, nextInvokeTimeout())

      promises.push({ resolve, reject })
    })
  }

  return debouncedFunction
}
